import ConfirmacionPago from "../pages/ConfirmacionPago";
import ConsultaCobranzas from "../pages/ConsultaCobranzas";
import ConsultaPagos from "../pages/ConsultaPagos";
import Desconfirmacion from "../pages/Desconfirmacion";
import IngresoPagoManual from "../pages/IngresoPagoManual";
import IngresoPagoMasivo from "../pages/IngresoPagoMasivo";
import RecaudacionPago from "../pages/RecaudacionPago";
import VinculacionManual from "../pages/VinculacionManual";
import ModificacionEstado from "../pages/ModificacionEstado";
import { TextLinkProps } from "../types-interfaces/interfaces";

export const PageList:Array<TextLinkProps> = [
  {
    text: 'Consultar cobranza',
    url: '/consultacobranzas',
    element: <ConsultaCobranzas className="consulta-cobranzas"/>,
    profiles: [1,2],
    type: "Consultas"
  },
  {
    text: 'Consultar pagos',
    url: '/consultapagos',
    element: <ConsultaPagos className="consulta-pagos"/>,
    profiles: [1,2],
    type: "Consultas"
  },
  {
    text: 'Ingreso pago manual',
    url: '/ingresopagomanual',
    element: <IngresoPagoManual className="ingreso-pago-manual"/>,
    profiles: [1],
    type: "Ingresos"
  },
  {
    text: 'Ingreso pago masivo',
    url: '/ingresopagomasivo',
    element: <IngresoPagoMasivo/>,
    profiles: [1],
    type: "Ingresos"
  },
  {
    text: 'Recaudación de pago',
    url: '/recaudacionpago',
    element: <RecaudacionPago className="recaudacion-pago"/>,
    profiles: [1]
  },
  {
    text: 'Confirmación de pago',
    url: '/confirmacionpago',
    element: <ConfirmacionPago className="confirmacion-pago"/>,
    profiles: [2]
  },
  {
    text: 'Desconfirmación',
    url: '/desconfirmacion',
    element: <Desconfirmacion className="desconfirmacion"/>,
    profiles: [2]
  },
  {
    text: 'Vinculación Manual',
    url: '/vinculacionmanual',
    element: <VinculacionManual className="vinculacionmanual"/>,
    profiles: [1]
  },
  {
    text: 'Modificación Estado',
    url: '/modificacionestado',
    element: <ModificacionEstado className="modificacion-estado"/>,
    profiles: [1,2]
  },
]